if (!customElements.get('drawer-nav')) {
  const EXPLAINER_KEY = 'parvum:drawer-explainer';

  class DrawerNav extends HTMLElement {
    #origin = null;

    connectedCallback() {
      this.dialog = this.closest('dialog');
      this.levels = new Map(
        Array.from(this.querySelectorAll('[data-level]')).map((el) => [el.dataset.level, el])
      );

      for (const push of this.querySelectorAll('[data-drawer-push]')) {
        if (push.tagName === 'A') {
          push.setAttribute('role', 'button');
          push.addEventListener('keydown', this.#pressOnSpace);
        }
        push.addEventListener('click', (event) => {
          event.preventDefault();
          this.#push(push.dataset.drawerPush, push);
        });
      }

      for (const back of this.querySelectorAll('[data-drawer-back]')) {
        back.addEventListener('click', () => this.#back());
      }

      this.#initExplainer();

      this.dialog?.addEventListener('close', () => this.#show('root', { focus: false }));
    }

    #pressOnSpace = (event) => {
      if (event.key !== ' ') return;
      event.preventDefault();
      event.currentTarget.click();
    };

    #push(name, origin) {
      if (!this.levels.has(name)) return;
      this.#origin = origin;
      this.#show(name);
    }

    #back() {
      this.#show('root');
      this.#origin?.focus({ preventScroll: true });
      this.#origin = null;
    }

    #show(name, { focus = true } = {}) {
      for (const [key, el] of this.levels) {
        const active = key === name;
        el.toggleAttribute('data-active', active);
        el.inert = !active;
      }

      const level = this.levels.get(name);
      if (!level) return;

      const title = level.querySelector('[id^="DrawerTitle-"]');
      if (title) this.dialog?.setAttribute('aria-labelledby', title.id);

      if (!focus || name === 'root') return;

      level.querySelector('[data-drawer-back]')?.focus({ preventScroll: true });
    }

    #initExplainer() {
      const toggle = this.querySelector('[data-drawer-explainer]');
      const panel = this.querySelector('[data-drawer-explainer-panel]');
      if (!toggle || !panel) return;

      let collapsed = true;
      try {
        collapsed = localStorage.getItem(EXPLAINER_KEY) !== 'open';
      } catch {}

      const apply = (isCollapsed) => {
        toggle.setAttribute('aria-expanded', String(!isCollapsed));
        panel.hidden = isCollapsed;
      };

      apply(collapsed);

      toggle.addEventListener('click', () => {
        const next = toggle.getAttribute('aria-expanded') === 'true';
        apply(next);
        try {
          localStorage.setItem(EXPLAINER_KEY, next ? 'collapsed' : 'open');
        } catch {}
      });
    }
  }

  customElements.define('drawer-nav', DrawerNav);
}
